export default "__VITE_ASSET__DXv1J8LN__$_?url__"